export const tablePageSizes = [10, 20, 50, 100, 10000];

export const LANGUAGECODES = [
  'en',
  'ar',
  'fr',
  'ru',
  'zh',
  'es',
  'ja',
  'pt',
  'it',
  'de',
];

export const LANGUAGECODETONAME = {
  en: 'English',
  ar: 'Arabic',
  fr: 'French',
  ru: 'Russian',
  zh: 'Chinese',
  es: 'Spanish',
  ja: 'Japanese',
  pt: 'Portuguese',
  it: 'Italian',
  de: 'German',
};

export const LANGUAGES = [
  { code: 'en', name: 'English' },
  { code: 'ar', name: 'Arabic' },
  { code: 'fr', name: 'French' },
  { code: 'ru', name: 'Russian' },
  { code: 'zh', name: 'Chinese' },
  { code: 'es', name: 'Spanish' },
  { code: 'ja', name: 'Japanese' },
  { code: 'pt', name: 'Portuguese' },
  { code: 'it', name: 'Italian' },
  { code: 'de', name: 'German' },
];

export const PRODUCTIDS = {
  melMoney: '690c95062db5b6e58f73efdd',
  silkyMusk: '690c93f32db5b6e58f73efd0 ',
};
